var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81818 9.89723H23.1818V8H6.81818C5.81818 8 5 8.85375 5 9.89723V21.2806C5 22.3241 5.81818 23.1779 6.81818 23.1779H10.4545V21.2806H6.81818V9.89723ZM15.9091 15.5889H12.2727V17.2775C11.7182 17.7992 11.3636 18.5391 11.3636 19.3834C11.3636 20.2277 11.7182 20.9676 12.2727 21.4893V23.1779H15.9091V21.4893C16.4636 20.9676 16.8182 20.2182 16.8182 19.3834C16.8182 18.5486 16.4636 17.7992 15.9091 17.2775V15.5889ZM14.0909 20.8063C13.3364 20.8063 12.7273 20.1708 12.7273 19.3834C12.7273 18.596 13.3364 17.9605 14.0909 17.9605C14.8455 17.9605 15.4545 18.596 15.4545 19.3834C15.4545 20.1708 14.8455 20.8063 14.0909 20.8063ZM24.0909 11.7945H18.6364C18.1818 11.7945 17.7273 12.2688 17.7273 12.7431V22.2292C17.7273 22.7036 18.1818 23.1779 18.6364 23.1779H24.0909C24.5455 23.1779 25 22.7036 25 22.2292V12.7431C25 12.2688 24.5455 11.7945 24.0909 11.7945ZM23.1818 21.2806H19.5455V13.6917H23.1818V21.2806Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesIcon);
export default __webpack_public_path__ + "static/media/DevicesIcon.4fbf6d7e.svg";
export { ForwardRef as ReactComponent };